/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import EmbeddedFormBlock from "./embedded-form-block.js";
import FormValidation from "./form-validation.js";

let embeddedFormBlockCntnr = document.querySelector("[data-embedded-form-block]");
if (embeddedFormBlockCntnr !== null) {
    let embeddedFormBlock = new EmbeddedFormBlock(embeddedFormBlockCntnr);
    let formValidation = new FormValidation(embeddedFormBlock);

    if (window.MsCrmMkt !== undefined) {
        MsCrmMkt.MsCrmFormLoader.on("formLoad",
            function (e) {
                e.preventFormLoadingProgressBar();
                embeddedFormBlock.showLoader();
            });

        MsCrmMkt.MsCrmFormLoader.on("afterFormLoad",
            function () {
                embeddedFormBlock.initialize();
                formValidation.initialize();
            });

        MsCrmMkt.MsCrmFormLoader.on("formSubmit",
            function (e) {
                embeddedFormBlock.showButtonSubmitting();
            });

        MsCrmMkt.MsCrmFormLoader.on("afterFormSubmit",
            function () {
                embeddedFormBlock.formCompleted = true;
                if (!embeddedFormBlock.isHidden) {
                    const efb = document.querySelector(".embedded-form-block-wrapper");
                    efb.scrollIntoView({ behavior: "smooth" });
                }

                if (embeddedFormBlock.openInModal) {
                    const $modal = $("#primaryCtaForm");
                    $modal.find(".form-description").hide();
                }

                window.dataLayer.push({
                    event: "formSubmissionSuccess",
                    formId: embeddedFormBlock.formName
                });
            });
    }
}
